export default __webpack_public_path__ + "static/media/opensea-icon.8469514f.svg";